import React from 'react';
import { connect } from 'react-redux';
import { isArray, isEmpty, isEqual } from 'lodash';

import { getAllReusableTransforms, initSchemaEditorOptions } from 'js/actions';
import {
  GET_CODE_CONTAINERS_REQUEST,
  GET_DATA_SET_REQUEST,
  GET_PUBLIC_CODE_CONTAINERS_REQUEST,
} from '../../../constants/actionTypes';
import { ACLQueryModeTypes } from '../../../constants/visibilityFilters';
import TransformsUtils from '../../../lib/TransformsUtils';
import { completeTxBuilderRecipeGroups } from 'js/lib/RecipeBuilderUtils';
import { CenteredLoader } from 'new/elements/CenteredLoader';
import RecipeGroupsList from '../../recipeBuilder/RecipeGroupsList';
import DataSetSplitRecipeTab from './DataSetSplitRecipeTab';

class DataSetRecipeTab extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      recipeGroups: [],
    };
  }

  componentDidMount() {
    const { initSchemaEditorOptions } = this.props;

    this._loadReusableTransforms();
    initSchemaEditorOptions();
    this._initRecipeGroups();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data?.id !== this.props.data?.id ||
      prevProps.data?.custom_config !== this.props.data?.custom_config ||
      prevProps.transforms !== this.props.transforms
    ) {
      this._initRecipeGroups();
    }
  }

  getRecipeGroups = () => {
    return this.state.recipeGroups;
  };

  setRecipeGroups = (recipeGroups) => {
    if (isEqual(this.state.recipeGroups, recipeGroups)) return;
    this.setState({ recipeGroups });
  };

  render() {
    const { data, parentDataSet, outputSchema } = this.props;

    if (this.props.isLoadingDataSet || this.props.isLoadingReusableTransforms) {
      return <CenteredLoader />;
    }

    const isSplitter = data?.node_type === 'splitter';
    const isParentSplitter = parentDataSet?.node_type === 'splitter';

    if (isSplitter || isParentSplitter) {
      return (
        <div className="tab-content recipe-tab recipe-builder">
          <DataSetSplitRecipeTab data={data} splitterDataSet={isSplitter ? data : parentDataSet} />
        </div>
      );
    }

    const dataSet = data;
    const recipeGroups = this.getRecipeGroups();

    return (
      <div className="tab-content recipe-tab recipe-builder">
        <section className="configure-recipe">
          <div className="configure-recipe-body">
            {isArray(recipeGroups) && isEmpty(recipeGroups) ? (
              <div className="recipe-group">
                <div className="recipe-group-title-container">
                  <h4>Detected Nexset</h4>
                </div>
                <div className="recipe-group-content">
                  <p>
                    This Nexset was detected from its source. Data ingestion recipes for this Nexset
                    are set by Nexla Platform.
                  </p>
                  <p>
                    You can assign descriptions to key schema attributes by clicking on the info
                    button of the attribute and setting attribute annotations.
                  </p>
                </div>
              </div>
            ) : (
              <RecipeGroupsList
                isReadOnly
                dataSet={dataSet}
                recipeGroups={recipeGroups}
                outputSchema={outputSchema}
                onLoadReusableTransforms={this._loadReusableTransforms}
              />
            )}
          </div>
        </section>
      </div>
    );
  }

  _initRecipeGroups = () => {
    const { data, transforms } = this.props;
    const txSpec = data.custom_config?.txSpec;
    let recipeGroups;

    if (txSpec?.v === 2) {
      recipeGroups = txSpec.spec;
    } else {
      recipeGroups = TransformsUtils.getUpgradedTxSpec(data, transforms);
    }

    recipeGroups = completeTxBuilderRecipeGroups(recipeGroups, transforms);

    this.setRecipeGroups(recipeGroups);
  };

  _loadReusableTransforms = () => {
    if (!this.props.isLoadingReusableTransforms) {
      this.props.getAllReusableTransforms(ACLQueryModeTypes.MODE_COLLABORATOR.key);
    }
  };
}

const mapStateToProps = (state, ownProps) => {
  const {
    data: { id, parent_data_set_id },
  } = ownProps;
  const {
    entities: { transforms, dataSets },
    dataSetSchemas,
    request,
  } = state;
  const parentDataSet = dataSets[parent_data_set_id] || null;
  const isLoadingReusableTransforms = !!(
    request[GET_CODE_CONTAINERS_REQUEST] || request[GET_PUBLIC_CODE_CONTAINERS_REQUEST]
  );

  return {
    transforms,
    parentDataSet,
    outputSchema: dataSetSchemas[id]?.out || [],
    isLoadingReusableTransforms,
    isLoadingDataSet: request[GET_DATA_SET_REQUEST],
  };
};

export default connect(mapStateToProps, {
  getAllReusableTransforms,
  initSchemaEditorOptions,
})(DataSetRecipeTab);
